import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education-system',
  templateUrl: './education-system.component.html',
  styleUrls: ['./education-system.component.scss'],
})
export class EducationSystem implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
